import axios from '../axios.js'

var other = {
  /**
   * 资源中心
  */
  // 获取资源中心列表
  getResources:function(data,success,failure){
    return axios.get('/resource/getResources',data,success,failure)
  },
  // 获取资源选择列表(不分页)
  getSelectResources:function(data,success,failure){
    return axios.get('/resource/getSelectResources',data,success,failure)
  },
  // 获取企业所有角色列表
  getCompanyRoles:function(data,success,failure){
    return axios.get('/role/getCompanyRoles',data,success,failure)
  },
  // 获取资源分类
  getProjectResourceTemps:function(data,success,failure){
    return axios.get('/projectResource/getProjectResourceTemps',data,success,failure)
  },
  // 获取历史记录
  getProjectHistorys:function(data,success,failure){
    return axios.get('/projectHistory/getProjectHistorys',data,success,failure)
  },
  // 获取工时筛选列表
  getSelectWorktimes:function(data,success,failure){
    return axios.get('/worktime/getSelectWorktimes',data,success,failure)
  },
  // 获取成员过滤列表
  getFilterMembers:function(data,success,failure){
    return axios.get('/resource/getFilterMembers',data,success,failure)
  },

  /**
   *文件管理 
  */
  // 上传文件
  uploadFile:function(data,success,failure){
    return axios.uploadPost('/upload/file',data,success,failure)
  },

  
  // 获取主体列表
  getCompanys:function(data,success,failure){
    return axios.get('/login/getCompanys',data,success,failure)
  },

  /**
   * 消息
  */
  // 获取我的未读消息
  getMyUnreadMessages:function(data,success,failure){
    return axios.get('/message/getMyUnreadMessages',data,success,failure)
  },
  // 获取我的未读消息数量
  getUnreadMessageSize:function(data,success,failure){
    return axios.get('/message/getUnreadMessageSize',data,success,failure)
  },
  // 删除我的消息
  deleteMessage:function(data,success,failure){
    return axios.post('/message/deleteMessage',data,success,failure)
  },
  // 删除我的消息(多条)
  deleteMessages:function(data,success,failure){
    return axios.post('/message/deleteMessages',data,success,failure)
  },
  // 获取我的所有消息列表
  getMyMessages:function(data,success,failure){
    return axios.get('/message/getMyMessages',data,success,failure)
  },
  // 标为已读
  setRead:function(data,success,failure){
    return axios.post('/message/setRead',data,success,failure)
  },
  // 查看我的消息详情
  getMessageInfo:function(data,success,failure){
    return axios.get('/message/getMessageInfo',data,success,failure)
  },
  // 一键已读
  setAllRead:function(data,success,failure){
    return axios.post('/message/setAllRead',data,success,failure)
  },

  /**
   * 微信API
  */
  // 获取微信公众号二维码
  getGzhCode:function(data,success,failure){
    return axios.get('/wx/getGzhCode',data,success,failure)
  },
  // 获取微信绑定二维码
  getWxCode:function(data,success,failure){
    return axios.get('/wx/getWxCode',data,success,failure)
  },
  // 解綁微信
  unbindWx:function(data,success,failure){
    return axios.get('/wx/unbindWx',data,success,failure)
  },
  //刷新token
  refreshToken:function(data,success,failure){
    return axios.post('/login/refreshToken',data,success,failure)
  },
}

export default other